import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: "flex",
    width: '100%',
    padding: theme.spacing(1)
  },
  grouped: {
    width: '100%',
    margin: `${theme.spacing(1)}px 0`,
    border: 'none',
    display: 'flex',
    columnGap: `12px`,
    '&:not(:first-child)': {
      borderRadius: theme.shape.borderRadius,
    },
    '&:first-child': {
      borderRadius: theme.shape.borderRadius,
    },
    borderRadius: '4px',
    justifyContent: 'space-between',
  },
  label: {
    fontSize: theme.spacing(1.5),
    textTransform: 'none',
    fontWeight: 600
  },
  icon: {
    height: 26,
  },
  iconSmall: {
    height: 16,
    minWidth: 32,
  }
}))

export default useStyles;
